var _a;
import { QueryClient } from 'react-query';
import { GraphQLClient } from 'graphql-request';
import { BASE_URL } from './config';
/**
 * The default options for the QueryClient.
 * Will not re-fetch the data when the window regains focus.
 * Will not retry to fetch the data when the request fails.
 * The timeout is set to 30 seconds before the data is considered stale and will be re-fetched.
 */
export var queryCache = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
export var requestHeaders = {
    'x-springhealth-client-path': (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname,
    authorization: 'Bearer MY_TOKEN',
};
export var graphqlRequestClient = new GraphQLClient(BASE_URL, {
    headers: requestHeaders,
});
